import React from 'react';
import { Chart } from 'react-google-charts';
import Spinner from '../../common/Spinner/Spinner';

const ExpertConsultationPieChart = ({ data, entrepreneursCount, allExpertConsultationDeliveredCount, isExpertConsultationChartDataLoading, isGetAllDeliveredCountLoading, isExpertConsultationLoading}) => {
    console.log(">>>>expert consultatio data", data);

    // // Mapping for custom labels based on sResourceID
    // const resourceLabels = {
    //     "Expert Clinic_JPMC_Market Linkage": "Market Readiness",
    //     "Expert Clinic_JPMC_Compliances": "Compliance Readiness",
    //     "Expert Clinic_JPMC_Loan Readiness": "Loan Readiness",
    //     "Expert Clinic_JPMC_Rahul Limaye": "Overall Growth Planning",
    //     "Expert Clinic_JPMC_Dr.Anand Godse": "Overall Growth Planning",
    //     "Expert Clinic_JPMC_Kavita_Awasthee": "Overall Growth Planning",
    //     "Expert Clinic_JPMC_Generic": "Overall Growth Planning",
    //     "Expert Clinic_JPMC_Bhaskar": "Social Media Marketing",
    //     "Expert Clinic_JPMC_Bhagyashri Mhatre": "Packaging & Labeling",
    //     "Expert Clinic_JPMC_Manisha Chandak": "Packaging & Labeling",
    //     "Expert Clinic_JPMC_Leena Khandekar": "Beauty Business Growth Planning",
    //     "Expert Clinic_JPMC_Sudhir Gijare": "Finance Improvement"
    // };

    // Count occurrences of each resource based on sResourceID
    const categoryCounts = {};

    // data.forEach(item => {
    //     const packageTitle = resourceLabels[item?.sPackageOfferTitle] ? resourceLabels[item.sPackageOfferTitle] : "Other";
    //     const count = item.sMobile_count || 1; // Default to 1 if sMobile_count is not present

    //     // Track total count for each resourceId
    //     resourceCounts[packageTitle] = (resourceCounts[packageTitle] || 0) + count;
    // });

    data.forEach(item => {
        const category = item.sCategory ? item.sCategory : "Other" ;
        const count = item.sMobile_count || 1; // If sMobile_count is not present, default to 1
        categoryCounts[category] = (categoryCounts[category] || 0) + count;
    });

    console.log(categoryCounts, ">>>>resourceCounts in expert consulation");
    

    // Prepare data for the pie chart with custom labels
    const chartData = Object.entries(categoryCounts).map(([category, count]) => [category, count]);

    console.log(chartData, ">>>> chart data in expert consultation");
    

    // Add header for the chart
    const chartHeader = [['Resource', 'Count'], ...chartData];

    return (
        <div>
            <div style={{ height: "55vh" }}>
                <div className={`${(isExpertConsultationChartDataLoading || isGetAllDeliveredCountLoading || isExpertConsultationLoading) ? "set-opacity" : ""}`} style={{ height: "100%", boxSizing: "border-box" }}>
                    {(isExpertConsultationChartDataLoading || isGetAllDeliveredCountLoading || isExpertConsultationLoading )? <Spinner className="center" /> : ""}
                    <Chart
                        width={'100%'}
                        height="100%"
                        chartType="PieChart"
                        loader={
                            <div className='d-flex align-items-center justify-content-center flex-column'
                                style={{ height: '55vh' }}>
                                Loading...
                            </div>
                        }
                        data={chartHeader}
                        options={{
                            backgroundColor: "#ddd",
                            // title: 'Market Linkage',
                            title: `${allExpertConsultationDeliveredCount} expert consultations delivered to ${entrepreneursCount} entrepreneurs`,
                            titleTextStyle: {
                                fontSize: 10,
                                bold: true,
                                color: "#333",
                            },
                            chartArea: {
                                left: "15%",  // Centers the chart horizontally
                                width: "78%", // Adjust width to allow space for the title
                                height: "50%", // Reduce height so title remains inside
                                top: 80, // Moves the chart down, keeping title inside
                            },
                        }}
                    />
                </div>
            </div>
        </div>
    );
};

export default ExpertConsultationPieChart;
